import {
   ServiceProvidingLocation,
   ServiceProvidingLocationForCurrentPracticeQuery,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { CqrsQueryPerformResult, performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { paginations } from '@dreryk/command-query-ws-client';
import { Slot } from '@dreryk/watermelon';

export const serviceProvidingLocationForCurrentPracticeSearchCreator = (withRemovedLocations?: boolean) => {
   return async (): CqrsQueryPerformResult<ServiceProvidingLocation[]> =>
      performCqrsQuerySearch<ServiceProvidingLocation>(
         () => {
            const query = new ServiceProvidingLocationForCurrentPracticeQuery();
            query.removed = Slot.emptyIfNull(withRemovedLocations ? null : false);
            return query;
         },
         paginations.all(),
         {
            cacheTime: 'short',
         }
      );
};
